var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 17.5C21.0938 17.5 23 19.4062 23 21.7188V22.5C23 23.3438 22.3125 24 21.5 24H10.5C9.65625 24 9 23.3438 9 22.5V21.7188C9 19.4062 10.875 17.5 13.1875 17.5C14.0938 17.5 14.5 18 16 18C17.4688 18 17.875 17.5 18.7812 17.5ZM21.5 22.5V21.7188C21.5 20.2188 20.2812 19 18.7812 19C18.3125 19 17.5938 19.5 16 19.5C14.375 19.5 13.6562 19 13.1875 19C11.6875 19 10.5 20.2188 10.5 21.7188V22.5H21.5ZM16 17C13.5 17 11.5 15 11.5 12.5C11.5 10.0312 13.5 8 16 8C18.4688 8 20.5 10.0312 20.5 12.5C20.5 15 18.4688 17 16 17ZM16 9.5C14.3438 9.5 13 10.875 13 12.5C13 14.1562 14.3438 15.5 16 15.5C17.625 15.5 19 14.1562 19 12.5C19 10.875 17.625 9.5 16 9.5Z",
    fill: "#07080C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.fba1f9014d0589830cb014d2b8e29ffe.svg";
export { ForwardRef as ReactComponent };